<template lang="">
    <div>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            nama: "AHM Oil Dashboard"
        }
    },
    methods:{
        testing(){
            //alert('test')
            let token = this.$route.query.token
            let product_category_id = this.$route.query.product_category_id
            let formData = {
                token : token, 
                product_category_id:product_category_id

            }
            this.$http.post('/api/sso/cross-client', formData)
			.then((resp) => {
                
                this.error = ''
				var user = resp.data.data;
                console.log('selamat datang');
				console.log(resp)

				this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;

				this.$store.dispatch('setUser', user);
            })
            .then(async () => {
				// let modules = await this.getModules();
				await this.loadFilterOptions();
				//NAVIGATION WILL BE HANDLED INSIDE LOADFILTER OPTIONS

				// console.log(modules ? 'Modules Successfully Loaded' : 'Modules Has Failed To Load');
			})
            .catch((error) => {
                console.log(error);
				this.$swal.fire({
					title : "Error!",
					icon : "error",
					type : "error",
					text : error.response.data.message
				})

                this.$router.push({name : 'Login'})

            })
        }
    },
    created(){
        this.testing()
    },
    computed:{
        token(){
            return this.$route.query.token
        }
    }
}
</script>
<style lang="">
    
</style>